// components/Footer.js
import React from "react";
import "../styles/general.css";

function Footer() {
  return (
    <footer>
      <p>&copy; 2024 Women Protection Analytics. All rights reserved.</p>
    </footer>
  );
}

export default Footer;
